import request, { gql } from "graphql-request";

export const CREATEINDUSTRY = gql`
  mutation CreateIndustry($input: CreateIndustryInput!) {
    createIndustry(input: $input) {
      success
      error
      message
    }
  }
`;

export const GETINDUSTRY = gql`
  query GetAllIndustries($search: String!, $page: Int!, $pageSize: Int!) {
    getAllIndustries(search: $search, page: $page, pageSize: $pageSize) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        industryType
        hiringType
      }
    }
  }
`;

export const GETINDUSTRYBYID = gql`
  query GetIndustryById($industryId: Int!) {
    getIndustryById(id: $industryId) {
      success
      error
      message
      data {
        id
        industryType
        hiringType
      }
    }
  }
`;

export const DELETEINDUSTRYBYID = gql`
  mutation DeleteIndustry($input: DeleteIndustryInput!) {
    deleteIndustry(input: $input) {
      success
      error
      message
    }
  }
`;

export const UPDATEINDUSTRYBYID = gql`
  mutation UpdateIndustry($input: UpdateIndustryInput!) {
    updateIndustry(input: $input) {
      success
      error
      message
      industry {
        id
        industryType
        hiringType
      }
    }
  }
`;
